import { getStoreCode } from '~/lib/getStoreCode'
import { REVIEWS_LANG_CONFIG } from './constants'

type LabelsType = {
  singular: string
  plural: string
}

export const initProductRating = (className: string, locale: string, labels: LabelsType) => {
  if (typeof window === 'undefined' || !(window as any).ratingSnippet) {
    return
  }

  const uninitializedCount = Array.from(
    window.document.querySelectorAll<HTMLElement>(`.${className}`),
  ).filter((el) => el.dataset?.done !== 'true').length

  if (uninitializedCount === 0) {
    return
  }

  const storeCode = getStoreCode({ locale }) || 'benuta_de'
  const lang = REVIEWS_LANG_CONFIG?.[storeCode] || 'de'

  ;(window as any).ratingSnippet(className, {
    store: 'benuta.de',
    mode: 'default',
    color: '#000000',
    linebreak: false,
    text: labels?.plural || 'Reviews',
    singularText: labels?.singular || 'Review',
    lang: lang,
    usePolaris: false,
    showEmptyStars: false,
    enableSyndication: true,
  })
}
